import { Toaster } from 'react-hot-toast';
import { createPortal } from 'react-dom';
import { theme } from 'utils/theme';

const ToasterPortal = () => {
    return createPortal(
        <Toaster
            toastOptions={{
                style: {
                    background: theme.gray_900,
                    color: theme.gray_50,
                    fontSize: '.875rem',
                    fontWeight: 600,
                },
                position: 'bottom-center',
                offset: 20,
            }}
        />,
        document.body,
    );
};

export default ToasterPortal;
